import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doOpenSaveOfferModal),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doCloseSaveOfferModal),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doSwitchPlanToSaveOffer),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSaveOfferSagas);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { takeEvery, put, call, all, fork } from 'redux-saga/effects';
import { saveOffer, userProfile } from 'redux/saga/entities/bound';
import { showModal, hideModal } from 'redux/modules/modals';
import { toggleFlag } from 'redux/modules/page';
import { replace as replacePath } from 'react-router-redux';
import { EFFECTIVE_NEXT_CYCLE } from 'constants/plan-change-effective-dates';
export var OPEN_SAVE_OFFER_MODAL = 'OPEN_SAVE_OFFER_MODAL';
export var CLOSE_SAVE_OFFER_MODAL = 'CLOSE_SAVE_OFFER_MODAL';
export var ACCEPT_SAVE_OFFER = 'ACCEPT_SAVE_OFFER';
export var SUBSCRIPTION_CHANGE_REQUEST = 'SUBSCRIPTION_CHANGE_REQUEST';
export var openSaveOffer = function openSaveOffer() {
  return {
    type: OPEN_SAVE_OFFER_MODAL
  };
};
export var closeSaveOffer = function closeSaveOffer() {
  return {
    type: CLOSE_SAVE_OFFER_MODAL
  };
};
export var acceptSaveOffer = function acceptSaveOffer() {
  return {
    type: ACCEPT_SAVE_OFFER
  };
};
export var SAVE_OFFER_MODAL = 'SaveOfferModal';
export function doOpenSaveOfferModal(props) {
  return regeneratorRuntime.wrap(function doOpenSaveOfferModal$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(showModal(SAVE_OFFER_MODAL, props));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doCloseSaveOfferModal() {
  return regeneratorRuntime.wrap(function doCloseSaveOfferModal$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([put(hideModal(SAVE_OFFER_MODAL)), put(replacePath('/settings/membership'))]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function doSwitchPlanToSaveOffer(client) {
  var _ref, _ref2, profile, offer;

  return regeneratorRuntime.wrap(function doSwitchPlanToSaveOffer$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return all([call(fetchEntityIfNeeded, userProfile, [client]), put(toggleFlag(SUBSCRIPTION_CHANGE_REQUEST))]);

        case 3:
          _ref = _context3.sent;
          _ref2 = _slicedToArray(_ref, 1);
          profile = _ref2[0];
          _context3.next = 8;
          return call(fetchEntityIfNeeded, saveOffer, [client, profile.id]);

        case 8:
          offer = _context3.sent;
          _context3.next = 11;
          return call(client.subscription.create, profile.id, {
            msa_id: offer.msa_id,
            plan_id: offer.id,
            effective: EFFECTIVE_NEXT_CYCLE
          });

        case 11:
          _context3.next = 13;
          return call(doOpenSaveOfferModal, {
            planChangeSuccessful: true
          });

        case 13:
          _context3.next = 19;
          break;

        case 15:
          _context3.prev = 15;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 19;
          return put(toggleFlag(SUBSCRIPTION_CHANGE_REQUEST));

        case 19:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 15]]);
}
export function watchSaveOfferSagas(client) {
  return regeneratorRuntime.wrap(function watchSaveOfferSagas$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return fork(takeEvery, OPEN_SAVE_OFFER_MODAL, doOpenSaveOfferModal);

        case 2:
          _context4.next = 4;
          return fork(takeEvery, CLOSE_SAVE_OFFER_MODAL, doCloseSaveOfferModal);

        case 4:
          _context4.next = 6;
          return fork(takeEvery, ACCEPT_SAVE_OFFER, doSwitchPlanToSaveOffer, client);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}